/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdbyperson2Inputs */

const de__field_createdbyperson2 = /** @type {(inputs: _Field_Createdbyperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`angelegt von`)
};

/**

* @param {_Field_Createdbyperson2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_createdbyperson2 = /** @type {((inputs?: _Field_Createdbyperson2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdbyperson2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_createdbyperson2(inputs)
});
export { _field_createdbyperson2 as "_field_createdByPerson" }